// extracted by mini-css-extract-plugin
module.exports = {"checkboxes":"ModalEvent_checkboxes__1ZwXT"};